import { RouteConfig } from './types';
import type { RoleResolverContext } from './resolveRole';
import { rideshareRoutes } from '@portals/rideshareRoutes';
import { contractorPortalRoutes } from '@portals/contractorPortalRoutes';
import { payerPortalRoutes } from '@portals/payerPortalRoutes';
import { memberPortalRoutes } from '@portals/memberPortalRoutes';
import { CONTRACTOR_USER, WEB_USER } from '@routes/helpers';

type RouteSource =
  | RouteConfig[]
  | ((config: RoleResolverContext) => RouteConfig[]);

export const routesByRole: Record<string, RouteSource> = {
  WEB_USER: rideshareRoutes,
  CONTRACTOR_USER: contractorPortalRoutes,
  payerPortal: payerPortalRoutes,
  memberPortal: memberPortalRoutes,
};

export const resolveRoutesForRole = (
  role:
    | typeof WEB_USER
    | typeof CONTRACTOR_USER
    | 'payerPortal'
    | 'memberPortal',
  ctx: RoleResolverContext
): RouteConfig[] => {
  const source = routesByRole[role];
  if (!source) return [];
  return typeof source === 'function' ? source(ctx) : source;
};
